<template>
  <div id="fh5co-wrapper">
    <div id="fh5co-page">
      <Header></Header>
      <div>
        <Price></Price>
      </div>
      <div class="fh5co-parallax mt-2 parallax-container-01">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-sm-offset-0 col-xs-12 col-xs-offset-0 fh5co-table">
              <div class="fh5co-intro fh5co-table-cell box-area">
                <div class="animate-box">
                  <h1>Home<br>Gym<br>&amp;<br>TRX<br>Training</h1>
                  <p></p>
                  <!-- <a href="https://coubic.com/legame/products#pageContent" target="_blank" rel="noopener noreferrer" class="btn btn-blue text-bold">480円～ 入会申込</a> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
import Footer from './Footer.vue'
import Price from './Price.vue'

export default {
  name: 'Course',
  data: function () {
    return {
      username: '',
      password: ''
    }
  },
  components: {
    Header,
    Footer,
    Price
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.signin-container {
  margin-top: 20px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}
input {
  margin: 10px 0;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Course.vue